import { Avatar } from "waapi/waap-ui/components/Avatar/Avatar.js";
import { Text } from "waapi/waap-ui/components/Text/Text.js";
import { TextSize, TextWeight } from "waapi/waap-ui/components/Text/Text.types.js";
import baseAvatar from "../../../../../../assets/blue-flat_waalien.svg";
import React from "react";
import { StyledRedCard } from "./styles.js";
import { AffiliationErrorProps } from "./types.js";

export const AffiliationError = (props: AffiliationErrorProps): JSX.Element => {
    const { affiliationError } = props;

    return (
        <StyledRedCard gap="12" direction="row" justify="center" align="center">
            <Avatar
                src={affiliationError?.affiliate?.profilePicture ?? baseAvatar}
                onError={(e: any) => {
                    e.target.src = baseAvatar;
                }}
            />
            <Text size={TextSize.MEDIUM} weight={TextWeight.NORMAL}>
                {affiliationError.affiliate.name}
            </Text>
        </StyledRedCard>
    );
};
